import React from 'react';
import Image from 'react-bootstrap/Image';
import letterIcon from '../../../images/mail.png';

function LetterImage() {
    
    return  <Image src={letterIcon} fluid alt="brev-ikon"/>;
    
}
export default LetterImage;